package org.matthewo.schema.games

import org.matthewo.math.minus
import org.matthewo.math.plus
import org.matthewo.schema.RankingMetrics
import org.matthewo.schema.StandardMetrics
import org.matthewo.symbolprocessor.GameSchema
import org.matthewo.symbolprocessor.Metric
import org.matthewo.symbolprocessor.Period

@GameSchema(2021, "Freight Frenzy", 2)
interface MetricsFreightFrenzy<T : Number> : StandardMetrics<T>, RankingMetrics<T> {
    override val tbp1 get() = auto

    @Metric(Period.AUTO, "Bonus")
    val apBonus: T
    @Metric(Period.AUTO, "Storage")
    val apStorage: T
    @Metric(Period.AUTO, "Level 1")
    val apLevel1: T
    @Metric(Period.AUTO, "Level 2")
    val apLevel2: T
    @Metric(Period.AUTO, "Level 3")
    val apLevel3: T
    @Metric(Period.AUTO, "Carousel")
    val apCarousel: T
    @Metric(Period.AUTO, "Navigation")
    val apNavigation: T

    @Metric(Period.TELEOP, "Storage")
    val tpStorage: T
    @Metric(Period.TELEOP, "Level 1")
    val tpLevel1: T
    @Metric(Period.TELEOP, "Level 2")
    val tpLevel2: T
    @Metric(Period.TELEOP, "Level 3")
    val tpLevel3: T
    @Metric(Period.TELEOP, "Shared")
    val tpShared: T

    @Metric(Period.ENDGAME, "Duck Deliver")
    val epDelivered: T
    @Metric(Period.ENDGAME, "Alliance Balance")
    val epAllianceBalance: T
    @Metric(Period.ENDGAME, "Shared Tip")
    val epSharedTip: T
    @Metric(Period.ENDGAME, "Cap")
    val epCap: T
    @Metric(Period.ENDGAME, "Park")
    val epPark: T
}

val <T : Number> MetricsFreightFrenzy<T>.alliance: T
    get() = apBonus +
            apLevel1 + apLevel2 + apLevel3 +
            tpLevel1 + tpLevel2 + tpLevel3 +
            epAllianceBalance

val <T : Number> MetricsFreightFrenzy<T>.shared: T
    get() = tpShared + epSharedTip

val <T : Number> MetricsFreightFrenzy<T>.carousel: T
    get() = apCarousel + epDelivered

fun <T : Number> MutableMetricsFreightFrenzy<T>.computeTotals() {
    auto = apBonus + apStorage + apLevel1 + apLevel2 + apLevel3 + apCarousel + apNavigation
    teleop = tpStorage + tpLevel1 + tpLevel2 + tpLevel3 + tpShared
    endgame = epDelivered + epAllianceBalance + epSharedTip + epCap + epPark
    npTotal = auto + teleop + endgame
    total = npTotal - penalty
}
